import { render, staticRenderFns } from "./uploadExtendedAttribute.vue?vue&type=template&id=2ca7b9c0&scoped=true"
import script from "./uploadExtendedAttribute.vue?vue&type=script&lang=js"
export * from "./uploadExtendedAttribute.vue?vue&type=script&lang=js"
import style0 from "./uploadExtendedAttribute.vue?vue&type=style&index=0&id=2ca7b9c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca7b9c0",
  null
  
)

export default component.exports